/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-param-reassign */
/* eslint-disable no-cond-assign */
/* eslint-disable radix */
import { toast } from 'react-toastify';
import { range } from 'lodash';
import parsePhoneNumber from 'libphonenumber-js';
import { ERROR_MESSAGE, MODEL_EPI } from './constants';
import moment from 'moment-timezone';
import { arrayType, dialToneOnly } from '../components/EpikBoxes/constants';
import store from '../../src/store'; // Import the Redux store

export default {
  generateErrorMessage: error => error?.response?.data || error?.meessage || ERROR_MESSAGE,
  sleep: ms => new Promise(res => setTimeout(res, ms)),
  sleepWithValue: (ms, val) => new Promise(res => setTimeout(() => res(val), ms)),
  getAuthToken: () => {
    return localStorage.getItem('jwtToken') || '';
  },
  getTimeDifferenceInMinutes: time => {
    if (typeof time === 'string' || time instanceof String) {
      // eslint-disable-next-line no-param-reassign
      time = new Date(time);
    }
    const currentTime = new Date();
    return parseInt((Math.abs(currentTime.getTime() - time.getTime()) / (1000 * 60)) % 60);
  },
  // validate email
  validateEmail(email) {
    // eslint-disable-next-line max-len,no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  // convert camel case string to title case i.e camelCase -> Camel Case
  toTitleCase(str) {
    const result = str.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  },
  // validate IP Address
  validateIPaddress(ipaddress) {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/\b([1-9]|[12][0-9]|3[012])\b$/.test(
        ipaddress,
      )
    ) {
      return true;
    }
    return false;
  },
  //get unique objects from array by replacing older
  getUniqueAndReplaceWithNew(array, key) {
    const unique = array.reduce((acc, item) => {
      const x = acc.find(obj => obj[key] === item[key]);
      if (!x) {
        acc.push(item);
      } else {
        acc.splice(acc.indexOf(x), 1, item);
      }
      return acc;
    }, []);
    return unique;
  },
  // remove empty key values from object
  removeEmptyKeyValues(obj) {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (obj[key] !== '') {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  },

  // returns date in MM/DD/YYYY format
  getDateFormate(date) {
    const formattedDate = date?.split?.('T');
    const [year, month, day] = formattedDate[0]?.split?.('-');
    const fullDate = `${month}/${day}/${year}`;
    return fullDate;
  },

  // check 502 error and return '502 Bad Gateway' in toast
  execute510Handler(error, toastId) {
    if (error.response && error.response.status === 510) {
      // Empty message to avoid showing any toast
    } else {
      // Error Message from API
      toast.error(error?.response?.data || error?.message || ERROR_MESSAGE, {
        toastId,
      });
    }
  },

  //  return the channelInput into new array
  validateChannelInput(value) {
    const rangeValue = [];
    const singleValue = [];
    let expandedArray = [];

    const input = value?.split(',');
    input.forEach(item => {
      if (item?.includes('-')) {
        rangeValue.push(item);
      }
      if (!item?.includes('-')) {
        singleValue.push(Number(item));
      }
    });
    expandedArray = rangeValue?.map(item => {
      let newArray = item?.split('-');
      if (Number(newArray[0]) < Number(newArray[1])) {
        newArray = range(Number(newArray[0]), Number(newArray[1]) + 1);
        return newArray;
      }
      return [];
    });
    const combine = singleValue.concat(...expandedArray);
    const uniqeValue = [...new Set(combine)];
    return uniqeValue?.sort((a, b) => a - b);
  },

  compareArrays(arr1, arr2) {
    return arr1.some(r => arr2.includes(r));
  },
  delay(duration) {
    return new Promise(resolve => setTimeout(resolve, duration));
  },

  verifyPhoneNumber(number = null) {
    const isNumberValid = parsePhoneNumber(number, 'US');
    if (!isNumberValid?.isValid()) {
      toast.error('Phone number is invalid');
      return false;
    }
    return true;
  },
  debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  removeNullish(arr) {
    return arr?.filter(item => item);
  },
  removeDashes(arr) {
    return arr?.map(item => item?.replace(/-/g, ' '));
  },
  ValidateIPaddress(ipaddress) {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress,
      )
    ) {
      return ipaddress;
    }
    return false;
  },
  validateOnlyPassword(password) {
    const hasPasswordNumbers = /\d/.test(password);
    if (!hasPasswordNumbers) {
      return false;
    }

    const isPasswordLengthValid = password && password.length >= 8;
    if (!isPasswordLengthValid) {
      return false;
    }

    const hasPasswordUpperCase = /[A-Z]/.test(password);
    if (!hasPasswordUpperCase) {
      return false;
    }

    const hasPasswordLowerCase = /[a-z]/.test(password);
    if (!hasPasswordLowerCase) {
      return false;
    }

    const hasPasswordSybmol = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/.test(password);
    if (!hasPasswordSybmol) {
      return false;
    }

    return true;
  },
  validatePassword(password, email) {
    const isPasswordLengthValid = password && password.length >= 8;
    if (!isPasswordLengthValid) {
      return false;
    }

    const userEmail = [email, email.toLowerCase()];
    const username = email.split('@');

    const isPasswordEmail = userEmail.includes(password) || username.includes(password);
    
    if (isPasswordEmail) {
      return false;
    }

    const hasPasswordNumbers = /\d/.test(password);
    if (!hasPasswordNumbers) {
      return false;
    }

    const hasPasswordUpperCase = /[A-Z]/.test(password);
    if (!hasPasswordUpperCase) {
      return false;
    }

    const hasPasswordLowerCase = /[a-z]/.test(password);
    if (!hasPasswordLowerCase) {
      return false;
    }

    const hasPasswordSybmol = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/.test(password);
    if (!hasPasswordSybmol) {
      return false;
    }

    return true;
  },
  showActivate(port, box, user) {
    let typeCheck = arrayType.includes(port?.assignedNumberRef?.type);
    if(port?.serviceName == dialToneOnly)
      typeCheck = true;
    if (typeCheck && !box.isDemoBox) {
      if (user?.role === 'superAdmin' || user?.role === 'companyGroupAdmin') {
        return true;
      }
      return false;
    }
    return false;
  },
  SignalStrengthCalculator(value) {
    value = value ? Number(value) : value;
    if (value === null) return 0;
    if (value > -61) {
      return 5;
    }
    if (value === -61 || value > -71) {
      return 4;
    }
    if (value === -71 || value > -81) {
      return 3;
    }
    if (value === -81 || value > -91) {
      return 2;
    }
    if (value >= -91) {
      return 0;
    }
    return 0;
  },
  
  // getDateTimeFormat(date, type) {
  //   if (date) {
  //     if (type === 'regular') {
  //       return moment(date).format('MMM DD, YYYY');
  //     }
  //     if (type === 'time') {
  //       return `${moment(date).format('hh:mm:ss az')} ${moment().tz(moment.tz.guess()).format('z')}`;
  //       ;
  //     }
  //     return `${moment(date).format('MMM DD, YYYY hh:mm:ss a')} ${moment().tz(moment.tz.guess()).format('z')}`;
  //   }
  //   return 'Date is not available';
  // },  
  /** Profile timezone when set; otherwise browser IANA zone (moment.tz.guess()). */
  getUserDisplayTimeZone() {
    let timeZone = store.getState().AppState.user?.timeZone;
    if (!timeZone || timeZone == 'browser') {
      timeZone = moment.tz.guess();
    }
    return timeZone;
  },
  /** Map box EPI timezone dropdown value to IANA (for interpreting device-reported times). */
  getEpiTimezoneAsIANA(epiCode) {
    const map = {
      est: 'America/New_York',
      cst: 'America/Chicago',
      mst: 'America/Denver',
      pst: 'America/Los_Angeles',
      ast: 'America/Anchorage',
      hst: 'Pacific/Honolulu',
    };
    const key = (epiCode || '').toString().toLowerCase();
    return map[key] || moment.tz.guess();
  },
  /**
   * Interprets OBi call history date/time in the box EPI zone, returns strings in the user's display zone.
   * Returns null if parsing fails (caller should show raw values).
   */
  formatPortCallHistoryDateTime(datePart, timePart, epiTimezoneCode) {
    const srcTz = this.getEpiTimezoneAsIANA(epiTimezoneCode);
    const destTz = this.getUserDisplayTimeZone();
    const d = (datePart || '').trim();
    const t = (timePart || '').trim();
    if (!d || !t) {
      return null;
    }
    const combined = `${d} ${t}`;
    const formats = [
      'M/D/YYYY h:mm:ss A',
      'MM/D/YYYY h:mm:ss A',
      'M/D/YYYY h:mm:ss a',
      'M/D/YYYY H:mm:ss',
      'MM/D/YYYY H:mm:ss',
      'M/D/YYYY h:mm A',
      'M/D/YYYY H:mm',
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD H:mm:ss',
    ];
    let m = moment.tz(combined, formats, true, srcTz);
    if (!m.isValid()) {
      m = moment.tz(combined, formats, true, moment.tz.guess());
    }
    if (!m.isValid()) {
      return null;
    }
    const zoned = m.clone().tz(destTz);
    return { date: zoned.format('MM/DD/YYYY'), time: zoned.format('hh:mm:ss A') };
  },
  getDateTimeFormat(date, type) {
    if (!date) {
      return 'Date is not available';
    }

    const timeZone = this.getUserDisplayTimeZone();

    let timezoneAbbr = moment().tz(timeZone).format('z');
    if (!/^[a-zA-Z]/.test(timezoneAbbr)) {
      timezoneAbbr = `UTC${timezoneAbbr}`;
    }
  
    const formats = {
      regular: 'MMM DD, YYYY',
      time: 'hh:mm:ss a',
      both: 'MMM DD, YYYY hh:mm:ss a'
    };
  
    const formattedDate = moment(date).tz(timeZone).format(formats[type] || formats['regular']);
    const correctFormattedDate = (type === 'time' || type === 'both' ) ? `${formattedDate} ${timezoneAbbr}` : `${formattedDate}`;
  
    return correctFormattedDate;
  },
  filterCustomer(role) {
    const roleCheck = ['user', 'admin', 'enterpriseAdmin', 'agent'].includes(role);
    if (roleCheck) {
      return false;
    }
    return true;
  },
  objectErrorHandler(error) {
    let message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    console.log("typeof ", typeof message_, message_[`${Object.keys(message_)[0]}`])
    message_ = typeof message_ == 'object' ? message_[`${Object.keys(message_)[0]}`] : message_
    toast.error(message_);
  },
  calculateEpiFirmwareUpdateTimer(epiFirmwareUpdateTimer){
    if (!epiFirmwareUpdateTimer) return true;

    const newData = new Date();
    const lastClickDate = new Date(epiFirmwareUpdateTimer);
    const mintDifference = newData?.getTime() - lastClickDate?.getTime();
    const epiFwUpdateTimer = mintDifference / 60000;

    return epiFwUpdateTimer > 15 ? true : false;
  },
  checkBoxVersionThirdOctet(vpnAddress = "") {
    const thirdOctet = parseInt(vpnAddress.split(".")[2]);
    return thirdOctet < 20 ? 'v2' : 'v3'; // Return 'v2' if third octet of the vpn address is less than 20, otherwise return 'v3'
  },
  getAllowedEPIs(modelNumber, hasExpansionModule) {
    if (modelNumber === 'G3-2400-e') return 12 // this is new model number which allows only 12 epis

    let allowedEPIs = 0;
    // Function to match the model number with possible variations
    const matchesModelNumber = (userInput, models) => {
      if (userInput == undefined || userInput == null) {
        return;
      }
      return models.some(model => {
        const baseModel = model.replace(/(\[.*\]\s*)/, '').replace(/[\.\-\/]/g, '\\$&');
        // Allow matching if user input is a partial match with the base model
        const pattern = new RegExp(`^${baseModel}[a-zA-Z0-9]*(\\..+)?$`);
        const baseInput = userInput?.trim().replace(/(\[.*\]\s*)/, '').replace(/[\.\-\/]/g, '\\$&');
        return pattern.test(userInput) || baseModel.startsWith(baseInput) || userInput.includes(baseModel);
      });
    }

    // Determine the base number of EPIs allowed based on the model number
    for (const [epiCount, models] of Object.entries(MODEL_EPI)) {
      if (matchesModelNumber(modelNumber, models)) {
        allowedEPIs = parseInt(epiCount, 10);
        break;
      }
    }

    // If the device has an expansion module, add 12 to the allowed EPIs
    if (hasExpansionModule) {
      allowedEPIs += 12;
    }

    return allowedEPIs;
  },
  // Check if a date is older than 24 hours
  isOlderThan24Hours(dateString) {
    if (!dateString) return false;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return false;
    const now = new Date();
    const diffMs = now - date;
    return diffMs > 24 * 60 * 60 * 1000;
  },
};

export const isAdminRole = (role) => ['enterpriseAdmin', 'admin'].includes(role);
export const isEscene = (macAddress) => macAddress?.startsWith('002');
export const isTrue = (value) => 
  value === true || value === 'true';



export const canAccessNotifications = role => {
  return (
    role === 'superAdmin' ||
    role === 'admin' ||
    role === 'enterpriseAdmin' ||
    role === 'companyGroupAdmin'
  );
};